import { useState, useEffect, useCallback } from 'react';
import { countMyOpen } from '../lib/tasks';

export default function useTaskBadge(userId) {
  const [n, setN] = useState(0);
  const refresh = useCallback(() => { if (userId) countMyOpen(userId).then(setN); }, [userId]);
  useEffect(() => { refresh(); const t = setInterval(refresh, 120000); return () => clearInterval(t); }, [refresh]);
  return [n, refresh];
}
